/* eslint-disable */ import { applicationConfigComponent, memoEval, sidebarTabsComponent, toolControlsComponent, viewControlsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const rootEntityComponents = [
    attachComponent.withComponent(applicationConfigComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            layout: 'tabs',
            distanceDataUnit: 'mm',
            initialGlobalUnit: 'mm',
            availableDimensions: [
                'mm'
            ],
            unitDisplayConfig: {
                mm: {
                    strategy: 'decimal',
                    decimalPlaces: 2
                }
            }
        }))),
    attachComponent.withComponent(sidebarTabsComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            tabs: [
                {
                    label: 'Plate',
                    navigationStates: [
                        'Dimensions'
                    ]
                },
                {
                    label: 'Add/Edit Features',
                    navigationStates: [
                        'Features'
                    ]
                },
                {
                    label: 'All Features',
                    navigationStates: [
                        'FeatureList'
                    ]
                }
            ]
        }))),
    attachComponent.withComponent(viewControlsComponent, 'default', true).withAlias('RootEntity').withFilter((s)=>s.$viewControlsFilter).attach(memoEval(()=>[], ()=>({
            items: [
                {
                    label: '3D View',
                    icon: 'Cube',
                    value: '3d'
                },
                {
                    label: 'Unfolded View',
                    icon: 'GridFour',
                    value: '2d'
                }
            ]
        }))),
    attachComponent.withComponent(toolControlsComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            items: [
                {
                    label: 'Configure',
                    value: 'Configure',
                    icon: 'BoundingBox'
                },
                {
                    label: 'Measure',
                    value: 'Measure',
                    icon: 'Ruler'
                }
            ]
        })))
];

//# sourceMappingURL=root-entity.js.map